// Vite injects env vars prefixed with VITE_ at build time. Read once at module
// load so the rest of the app doesn't need to know about Vite specifics.
export const env = {
	liffId: import.meta.env.VITE_LIFF_ID ?? "",
	apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8000",
} as const;
